import {
  CLEAR_UPDATED_DATA_LOCK,
  LOAD_DATA_LOCKS_FAIL,
  LOAD_DATA_LOCKS_START,
  LOAD_DATA_LOCKS_SUCCESS,
  UPDATE_DATA_LOCKS_FAIL,
  UPDATE_DATA_LOCKS_START,
  UPDATE_DATA_LOCKS_SUCCESS,
} from 'actions/externalDataPage';

const defaultState = {
  data: [],
  error: false,
  loading: true,
  total: 0,
  updated: {
    dataLockType: null,
    error: null,
  },
};

const createDataLocksArray = dataLocks =>
  Object.keys(dataLocks)
    .map(lockName =>
      Object.keys(dataLocks[lockName]).map(propertyName => ({
        objectType: lockName,
        property: propertyName,
        locked: dataLocks[lockName][propertyName],
      })),
    )
    .flat();

export default function externalDataPage(state = defaultState, action) {
  switch (action.type) {
    case CLEAR_UPDATED_DATA_LOCK:
      return {
        ...state,
        updated: { ...defaultState.updated },
      };
    case LOAD_DATA_LOCKS_START:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case LOAD_DATA_LOCKS_FAIL:
      return {
        ...state,
        error: true,
        loading: false,
      };
    case LOAD_DATA_LOCKS_SUCCESS: {
      const { dataLocks } = action.payload;
      const dataLocksArray = createDataLocksArray(dataLocks);
      return {
        ...state,
        data: dataLocksArray,
        error: false,
        loading: false,
        total: dataLocksArray.length,
      };
    }
    case UPDATE_DATA_LOCKS_START:
      return {
        ...state,
        updated: {
          dataLockType: null,
          error: null,
        },
      };
    case UPDATE_DATA_LOCKS_FAIL:
      return {
        ...state,
        updated: {
          dataLockType: null,
          error: {
            ...action.payload,
            failedDataLockType: action.modifiedObjectType,
          },
        },
      };
    case UPDATE_DATA_LOCKS_SUCCESS: {
      return {
        ...state,
        updated: {
          dataLockType: action.modifiedObjectType,
          error: false,
        },
      };
    }
    default:
      return state;
  }
}
